import { render } from "./ChallengesResultsLinks.vue?vue&type=template&id=49c4347a"
import script from "./ChallengesResultsLinks.vue?vue&type=script&lang=js"
export * from "./ChallengesResultsLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__